<mat-toolbar color="accent">ACC Claim</mat-toolbar>

<div class="flex flex-col gap-4 bg-gray-50 p-4">
  <div class="flex flex-col gap-4">
    <pr-information-box>
      Select an ACC claim or enter existing claim details to submit an invoice
      to ACC.
    </pr-information-box>

    <div class="flex gap-4">
      <mat-form-field subscriptSizing="dynamic" class="flex-1">
        <mat-label>Select Claim</mat-label>
        <mat-select [formControl]="claimRequestCtrl">
          <mat-select-trigger>
            {{ claimRequestCtrl.value | map: getClaimSelectTitle : this }}
          </mat-select-trigger>
          <mat-option class="opacity-80" [value]="existingClaimOption">
            <mat-icon class="icon-sm" fontSet="material-symbols-outlined">
              edit_document
            </mat-icon>
            <span class="font-medium">Enter Existing Claim Details</span>
          </mat-option>
          <mat-divider />

          @for (request of data.accClaims; track request.ref.path) {
            @if (request.data.claimData.claimNumber; as claimNumber) {
              <mat-option class="opacity-90" [value]="request">
                <span class="font-medium">{{ claimNumber }}</span> -
                {{ request.createdAt | moment | amDateFormat: dateFormat }}
                @if (request.data.testMode) {
                  <pr-acc-test-chip />
                }
              </mat-option>
            }
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic" class="flex-1">
        <mat-label>Prior Approval Purchase Order #</mat-label>
        <input matInput [formControl]="purchaseOrderNumberCtrl" />
      </mat-form-field>
    </div>

    @if (claimRequestCtrl.value === existingClaimOption) {
      <pr-acc-existing-claim-form [form]="existingClaimForm" />
    }

    <pr-acc-claim-details-display
      *ngIf="selectedClaimData$ | async as claimData"
      [claimData]="claimData"
    />
  </div>

  <pt-buttons-container>
    <button
      mat-flat-button
      color="primary"
      [disabled]="disabled$ | async"
      (click)="submit()"
    >
      Submit Invoice
    </button>
  </pt-buttons-container>
</div>
